import * as Phaser from "phaser-ce"
import { Scale } from "../utils/Scale"
import { GenericAssets } from "./GenericAssets"

export class CigaretteSprite extends Phaser.Sprite {

    private lightAnim: Phaser.Animation
    private smokeAnim: Phaser.Animation

    constructor(game: Phaser.Game, x: number, y: number, defaultScale = 1, group?: Phaser.Group) {
        super(game, x, y, GenericAssets.CIGARETTE)

        if (group) {
            group.add(this)
        } else {
            game.add.existing(this)
        }
        Scale.scaleSprite(this, defaultScale)

        this.lightAnim = this.animations.add("light", [0, 1, 2, 3, 4, 5, 6, 7, 8])
        this.smokeAnim = this.animations.add("smoke",
            [9, 10, 11, 12, 13, 14, 15, 16, 17, 16, 15, 14, 13, 12, 11, 10])
        this.lightAnim.onComplete.add(() => {
            this.smokeAnim.play(8, true)
        })
    }

    smoke = () => {
        this.lightAnim.play(8)
    }

    stopSmoke = () => {
        this.animations.stop()
        this.animations.frame = 0
    }
}
